import { EventCard } from '@rouvydev/web-components/cards'
import { type PointRoute } from '@rouvydev/web-components/content'
import { useTranslation } from 'react-i18next'
import { ThumborUrlBuilder } from 'thumbor-url-builder-ts'
import { ExpandCard } from './expand-card.tsx'
import { NormalizedLink } from '~/components/normalized-link.tsx'
import { type EventInfo, EventInfoType } from '~/model/api.ts'
import {
  convertMetersToKm,
  useUnitConversion,
} from '~/utils/unit-conversions.ts'

const thumbor = new ThumborUrlBuilder(ENV.THUMBOR_SECURITY, ENV.THUMBOR_URL)

export function EventInfoCard(
  props: EventInfo & {
    official?: boolean
    displayStartDateTime?: string
    expand?: boolean
    className?: string
  },
) {
  const { t } = useTranslation(['collections'])
  const { convertDistance, convertElevation } = useUnitConversion()

  const url = `${ENV.RIDERS_PORTAL_URL}/events/${props.defaultSessionId}`

  const route = props.routeCard?.data?.attributes

  const routePoints = route?.simplifiedGeometryPoints
    ? (route?.simplifiedGeometryPoints as []).map(
        (point) =>
          ({
            distance: point['distance'],
            altitude: point['altitude'],
          }) as PointRoute,
      )
    : []

  const img =
    props.mainPhoto?.data?.attributes?.url ??
    props.coverPhoto?.data?.attributes?.url ??
    route?.thumbnailUrl

  const imageUrl = img
    ? thumbor.setImagePath(encodeURIComponent(img)).buildUrl()
    : undefined

  const eventTypeLabel =
    props.type === EventInfoType.Race
      ? t('event_type_race')
      : t('event_type_group_ride')

  return (
    <ExpandCard
      card={
        <EventCard
          event={{
            title: props.title,
            image: imageUrl,
            link: <NormalizedLink to={url} />,
            startDateTime: props.displayStartDateTime ?? '',
            type: eventTypeLabel,
            distance: convertDistance(convertMetersToKm(route?.distanceMeters)),
            elevation: convertElevation(route?.ascendedMeters),
            routeGeometry: routePoints,
          }}
          strings={{
            joined: t('joined'),
            recommended: t('recommended'),
          }}
          useFixedSize
        />
      }
      expand={props.expand === true}
      expandedTitle={props.expandTitle ?? props.title}
      expandedDescription={props.description ?? undefined}
      link={url}
      className={props.className}
    />
  )
}
